import type { InvestorEntityType } from '@/lib/investor/routing/types';

/**
 * Stable identity and provenance shared by Action Center, Activity, drawers,
 * and governed workspaces. Display labels are intentionally excluded: they
 * are presentation data and must never become record authority.
 */
export interface CanonicalInvestorEntityReference {
    entityId: string;
    entityType: InvestorEntityType;
    workspaceId?: string;
    organizationId?: string;
    investmentId?: string;
    positionIds?: string[];
    projectId?: string;
    sourceSystem: string;
    asOf: string;
    currency?: string;
    period?: {
        start: string;
        end: string;
    };
    provenance: {
        authority: string;
        projection?: string;
        version?: string;
        [key: string]: unknown;
    };
}

export function canonicalEntityId(
    reference: CanonicalInvestorEntityReference | undefined,
    legacyReferenceId: string | undefined,
): string | undefined {
    return reference?.entityId || legacyReferenceId;
}
